import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

// TODO: Replace with your actual Strava API credentials
// You can get these from https://www.strava.com/settings/api
const STRAVA_CLIENT_ID = '187116';
const STRAVA_REDIRECT_URI = window.location.origin;

export const getStravaAuthUrl = () => {
  const params = new URLSearchParams({
    client_id: STRAVA_CLIENT_ID,
    redirect_uri: STRAVA_REDIRECT_URI,
    response_type: 'code',
    approval_prompt: 'force', // Force re-authorization to ensure correct scopes
    scope: 'activity:read_all',
  });
  return `https://www.strava.com/oauth/authorize?${params.toString()}`;
};

export const exchangeToken = async (code: string) => {
  const exchangeStravaToken = httpsCallable(functions, 'exchangeStravaToken');
  try {
    const result = await exchangeStravaToken({ code });
    return result.data;
  } catch (error: any) {
    console.error("Error exchanging token:", error);
    // Preserve the error message from Cloud Function (HttpsError)
    // Firebase Cloud Functions errors have a 'message' property with our custom message
    const errorMessage = error?.message || error?.details?.message || 'Không thể kết nối với Strava. Vui lòng thử lại sau.';
    throw new Error(errorMessage);
  }
};

export const syncActivities = async () => {
  const syncActivitiesFn = httpsCallable(functions, 'syncActivities');
  try {
    const result = await syncActivitiesFn();
    return result.data;
  } catch (error) {
    console.error("Error syncing activities:", error);
    throw new Error('Failed to sync activities');
  }
};
